import { FC, useMemo } from "react";

import { Document, Image, Page, StyleSheet, Text, View } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
    height: "100%",
  },
  imageContainer: {
    width: "100%",
    alignItems: "center",
  },
  image: {
    width: 1050,
    height: 350,
    objectFit: "contain",
  },
  text: {
    fontSize: 12,
    textAlign: "center",
  },
});

export const StoryboardPdf: FC<{ images: string[] }> = ({ images }) => {
  const numPages = useMemo(() => Math.ceil(images.length / 2), [images]);

  return (
    <Document>
      {Array.from({ length: numPages }, (_, pageIndex) => (
        <Page style={styles.page} key={pageIndex}>
          {images.slice(pageIndex * 2, pageIndex * 2 + 2).map((src, index) => (
            <View style={styles.imageContainer} key={index}>
              <Text style={styles.text}>Step {pageIndex * 2 + index + 1}</Text>
              <Image style={styles.image} src={src} />
            </View>
          ))}
        </Page>
      ))}
    </Document>
  );
};
